<template>
  <div class="d-inline-block">
    <v-btn x-small depressed color="purple lighten-5" class="text-capitalize" dark @click="getInputOptions(value)">
      <v-icon size="10" color="purple" class="mr-1">mdi-pencil</v-icon>
      <span class="purple--text">Options</span>
    </v-btn>
    <v-dialog v-model="dialog" persistent max-width="650">
      <v-card>
        <v-card-title class="headline title">
          <v-icon left color="black">mdi-plus</v-icon>
          Input'a Opsiyon Ekle
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-2">
          <v-col cols="12">
            <language-structured-data v-if="optionListLangData" ref="languageStructuredData" v-model="optionListLangData">
              <template v-slot="{ data, currentCode }">
                <v-row>
                  <v-col cols="12" lg="5">
                    <v-text-field solo dense label="Özellik adı" prepend-inner-icon="mdi-form-textbox" hide-details v-model="data.optText"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="5">
                    <v-text-field solo dense label="Özellik değeri" prepend-inner-icon="mdi-form-textbox" hide-details v-model="optionListData.value"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="2" class="d-flex align-center justify-center px-0">
                    <v-tooltip v-if="isAdd" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-on="on" v-bind="attrs" color="blue" class="text-capitalize" dark :loading="addIOLoading" fab x-small @click="addInputOption">
                          <v-icon size="18">mdi-plus-circle</v-icon>
                        </v-btn>
                      </template>
                      <span>Seçeneği Ekle</span>
                    </v-tooltip>
                    <v-tooltip v-else-if="isEdit" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-on="on" v-bind="attrs" color="green" class="text-capitalize" dark :loading="updateIOLoading" fab x-small @click="updateInputOption">
                          <v-icon size="17">mdi-autorenew</v-icon>
                        </v-btn>
                      </template>
                      <span>Seçeneği Güncelle</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" x-small color="yellow" fab class="ml-2" @click="cancelOperation">
                          <v-icon>mdi-minus</v-icon>
                        </v-btn>
                      </template>
                      <span>Sıfırla</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </template>
            </language-structured-data>
          </v-col>
          <v-col cols="12">
            <p class="subtitle-1 mb-0">
              <b>Input Opsiyon Listesi</b>
            </p>
            <v-divider class="mb-2"></v-divider>
            <input-options-list v-if="inputOptions.length > 0" v-model="inputOptions" @getInputOption="getInputOption" @deleteInputOption="deleteInputOptionDialog" @change="updateInputOptionsQueue" />
            <p v-else class="text-center pt-3">
              Tanımlanmış seçenek bulunmamaktadır
            </p>
          </v-col>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" dark @click="closeDialog()">Kapat</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="inputOptionDelete.deleteIODialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          Uyarı
        </v-card-title>
        <v-card-text>Input'a ait opsiyonu silmek istediğinizden emin misiniz ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="inputOptionDelete.deleteIODialog = false">İptal</v-btn>
          <v-btn color="green darken-1" text :loading="inputOptionDelete.deleteIOLoading" @click="deleteInputOption">
            Evet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OptionService from "@/services/OptionService";
import { mapState } from "vuex";
import InputOptionsList from "./InputOptionsList";
import LanguageStructuredData from "@/components/LanguageStructuredData.vue";
import { prepare, prepareFromData } from "@/core/modules/LanguageStructuredData";

export default {
  name: "InputOptions",
  components: { LanguageStructuredData, InputOptionsList },
  props: {
    value: {
      required: true,
      default: ""
    }
  },
  data: () => ({
    dialog: false,
    optionListLangData: null,
    optionListData: {
      value: ""
    },
    inputOptionDelete: {
      deleteIODialog: false,
      deleteIOCode: "",
      deleteIOLoading: false
    },
    inputOptions: [],
    optionListLangDataEdit: "",
    resetOptionData: false,
    type: "add",
    addIOLoading: false,
    updateIOLoading: false
  }),
  methods: {
    getInputOptions(inputCode) {
      OptionService.inputOptions({ inputCode }).then(res => {
        if (res.status === 200) {
          this.inputOptions = res.data;
          this.dialog = true;
        }
      });
    },
    addInputOption() {
      const inputCode = this.value,
        optionData = this.$refs.languageStructuredData.languageStructuredData.getAsRequestPayload(),
        optValue = this.optionListData.value;

      this.addIOLoading = true;
      OptionService.addInputOption({ inputCode, ...optionData, optValue })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success("Input opsiyonu başarılı bir şekilde eklenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
            this.getInputOptions(inputCode);
            this.resetData();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
          this.addIOLoading = false;
        })
        .then(() => {
          this.resetOptionData = false;
        });
    },
    updateInputOption() {
      const inputCode = this.value,
        optionData = this.$refs.languageStructuredData.languageStructuredData.getAsRequestPayload(),
        optValue = this.optionListData.value,
        optCode = this.optionListLangDataEdit[0].code;

      this.updateIOLoading = true;
      OptionService.updateInputOption({
        optCode,
        inputCode,
        ...optionData,
        optValue
      })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success("Input opsiyonu başarılı bir şekilde güncellenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
            this.getInputOptions(inputCode);
            this.resetData();
          } else {
            this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
          }
          this.updateIOLoading = false;
        })
        .then(() => {
          this.resetOptionData = false;
        });
    },
    getInputOption(optCode) {
      const inputCode = this.value;
      OptionService.getListOption({ inputCode, optCode }).then(res => {
        if (res.status === 200) {
          this.type = "edit";
          this.optionListLangDataEdit = res.data;
          this.optionListLangData = prepareFromData(res.data, { text: "optText" });
          this.optionListData.value = res.data[0].value;
        }
      });
    },
    deleteInputOptionDialog(optCode) {
      this.inputOptionDelete.deleteIOCode = optCode;
      this.inputOptionDelete.deleteIODialog = true;
    },
    deleteInputOption() {
      const inputCode = this.value;
      this.inputOptionDelete.deleteIOLoading = true;
      OptionService.deleteInputOption({
        optCode: this.inputOptionDelete.deleteIOCode
      }).then(res => {
        if (res.status === 200) {
          this.$snotify.success("Input opsiyonu sistemden kaldırılmıştır", this.$t('PANEL.NOTIFY.SUCCESS'));
          this.getInputOptions(inputCode);
          this.resetData();
          this.inputOptionDelete.deleteIODialog = false;
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
        this.inputOptionDelete.deleteIOLoading = false;
      });
    },
    updateInputOptionsQueue() {
      const optsList = this.inputOptions,
        inputCode = this.value;

      OptionService.updateInputOptionsQueue({ optsList }).then(res => {
        if (res.status === 200) {
          this.$snotify.success("Opsiyon liste sırası güncellenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
          this.getInputOptions(inputCode);
        } else {
          this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
        }
      });
    },
    cancelOperation() {
      this.resetData();
    },
    closeDialog() {
      this.resetData();
      this.dialog = false;
    },
    resetData() {
      this.type = "add";
      Object.keys(this.languages).forEach(languageCode => {
        this.$set(this.optionListLangData[languageCode], "optText", null);
      });
      this.optionListData.value = "";
      this.resetOptionData = !this.resetOptionData;
    }
  },
  computed: {
    ...mapState({
      apiLanguage: state => state.Language.apiLanguage,
      languages: state => state.Language.languages
    }),
    isAdd() {
      return this.type === "add";
    },
    isEdit() {
      return this.type === "edit";
    }
  },
  created() {
    if (this.isAdd) {
      this.optionListLangData = prepare(this.apiLanguage, {
        optText: ""
      });
    }
  }
};
</script>

<style></style>
